export const CONTENT_NAME_TOKEN = "{content.name}";

export const ANCILLARY_TITLE_TOKEN = "{ancillary.title}";

export const MOVIE_TITLE_TOKEN = "{movie.title}";

export const TV_SERIES_TITLE_TOKEN = "{tvSeries.title}";

export const SEASON_NAME_TOKEN = "{season.name}";

export const EPISODE_TITLE_TOKEN = "{episode.title}";

export const EPISODE_NUMBER_TOKEN = "{episode.number}";
